import React, { Component } from 'react';

import { DefaultFieldNames } from 'common/constants/ideas';
import Highlight from 'common/developers/docs/api/Highlight';
import {
  AlphanumericConditions,
  BooleanConditions,
  DateConditions,
  DropdownConditions,
  MultiselectConditions,
  NumericConditions,
} from 'common/fieldFilters/utils';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsIdeaFilteringObjectBlock extends Component {
  createdAt = new Date();

  renderValueList(values) {
    return values.map((value) => `"${value}"`).join(', ');
  }

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The filtering object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                heading: 'filters',
                subheading: 'array',
                description: (
                  <div className="space-y-4">
                    <p>
                      An array of filters to apply to the ideas. Should contain, resource, condition
                      and value.
                    </p>
                    <div className="space-y-2">
                      <p>
                        <strong>Resources:</strong> ideaDefaultField.
                      </p>
                      <p>
                        <strong>Conditions:</strong> Should be one of the ones listed below.
                      </p>
                      <p>
                        <strong>Value:</strong>
                      </p>
                      <ul className="list-disc pl-5">
                        <li>
                          <strong>fieldID:</strong> The ID of the field to filter by. Should be one
                          of the ones listed below.
                        </li>
                        <li>
                          <strong>value:</strong> The value to filter by. Should be one of the ones
                          listed below.
                        </li>
                      </ul>
                    </div>

                    <p>
                      <strong>Default Field IDs:</strong>{' '}
                      {this.renderValueList(Object.values(DefaultFieldNames))}
                    </p>

                    <div className="space-y-2">
                      <div className="mt-5">
                        <strong>Fields Conditions:</strong>
                      </div>
                      <ul className="list-disc pl-5">
                        <li>
                          <strong>Text Field:</strong>{' '}
                          {this.renderValueList(Object.values(AlphanumericConditions))}
                        </li>
                        <li>
                          <strong>Numeric Field:</strong>{' '}
                          {this.renderValueList(Object.values(NumericConditions))}
                        </li>
                        <li>
                          <strong>Alphanumeric Field:</strong>{' '}
                          {this.renderValueList(Object.values(AlphanumericConditions))}
                        </li>
                        <li>
                          <strong>Dropdown Field:</strong>{' '}
                          {this.renderValueList(Object.values(DropdownConditions))}
                        </li>
                        <li>
                          <strong>Multiselect Field:</strong>{' '}
                          {this.renderValueList(Object.values(MultiselectConditions))}
                        </li>
                        <li>
                          <strong>Boolean Field:</strong>{' '}
                          {this.renderValueList(Object.values(BooleanConditions))}
                        </li>
                        <li>
                          <strong>Date Field:</strong>{' '}
                          {this.renderValueList(Object.values(DateConditions))}
                        </li>
                      </ul>
                    </div>
                  </div>
                ),
              },
              {
                heading: 'filtersOperator',
                subheading: 'string',
                description:
                  'The operator to apply to the filters. Can be "all" (AND) or "any" (OR).',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example filtering object:</div>
          <Highlight lang="json">
            {`{
  "filters": [
    {
      "resource": "ideaDefaultField",
      "condition": "is",
      "value": {
        "fieldID": "title",
        "value": "My Awesome Idea"
      }
    }
  ],
  "filtersOperator": "all"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
